export var templatePageComponents = {
    v8: {
        profile: {
            components: [
                { id: 'comp-l31fhrlc', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l31fhrli', role: "title" /* ComponentsRole.TITLE */ },
            ],
            controller: 'comp-l31fhrl98',
        },
        myaccount: {
            components: [
                { id: 'comp-l31g09r8', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l31g09rc7', role: "title" /* ComponentsRole.TITLE */ },
            ],
            controller: 'comp-l31g09r53',
        },
        settings: {
            components: [
                { id: 'comp-l7hq3ny08', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l7hq3ny5', role: "title" /* ComponentsRole.TITLE */ },
            ],
            controller: 'comp-l7hq3nxm8',
        },
        notifications: {
            components: [
                { id: 'comp-l7hqod8u7', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l7hqod8x4', role: "title" /* ComponentsRole.TITLE */ },
            ],
            controller: 'comp-l7hqod8i8',
        },
        list: {
            // list
            components: [
                { id: 'comp-l1mmr4ac8', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l1mmr4a56', role: "listSubtitle" /* ComponentsRole.SUBTITLE */ },
                { id: 'comp-l1mmr4a28', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l1af0dbv', role: "shareBox" /* ComponentsRole.SHARE_CONTAINER */ },
                { id: 'comp-l1uwpa482', role: "shareMobile" /* ComponentsRole.SHARE_MOBILE */ },
                { id: 'comp-l1mmr49w', role: "heartIcon" /* ComponentsRole.HEART_ICON */ },
                { id: 'comp-l1af0dbl', role: "downloadBox" /* ComponentsRole.DOWNLOAD_CONTAINER */ },
                { id: 'comp-l1af0dbo1', role: "downloadButton" /* ComponentsRole.DOWNLOAD_BUTTON */ },
                { id: 'comp-l1uwpa402', role: "downloadMobile" /* ComponentsRole.DOWNLOAD_MOBILE */ },
                { id: 'comp-l1af0dcr3', role: "facebook" /* ComponentsRole.FACEBOOK */ },
                { id: 'comp-l1af0dcq', role: "pinterest" /* ComponentsRole.PINTEREST */ },
                { id: 'comp-l1af0dco', role: "twitter" /* ComponentsRole.TWITTER */ },
                { id: 'comp-l1af0dcm', role: "tumblr" /* ComponentsRole.TUMBLR */ },
                { id: 'comp-l1af0dck', role: "email" /* ComponentsRole.EMAIL */ },
                { id: 'comp-l1w44wo3', role: "loginBox" /* ComponentsRole.LOGIN_BOX */ },
            ],
            controller: 'comp-l1mmr49x2',
        },
        lists: {
            // lists
            components: [
                { id: 'comp-l1opj0yi5', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l1opj0y75', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l1opj0xy', role: "heartIcon" /* ComponentsRole.HEART_ICON */ },
                { id: 'comp-l1opj0y2', role: "cartIcon" /* ComponentsRole.CART_ICON */ },
                { id: 'comp-l1w4464h', role: "loginBox" /* ComponentsRole.LOGIN_BOX */ },
            ],
            controller: 'comp-l1opj0y01',
        },
        sets: {
            // sets
            components: [
                { id: 'comp-l1opi7wr', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l1opi7w52', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l1opi7vr', role: "heartIcon" /* ComponentsRole.HEART_ICON */ },
                { id: 'comp-kzdxtru4', role: "shareBox" /* ComponentsRole.SHARE_CONTAINER */ },
                { id: 'comp-l1uvxmyv1', role: "shareMobile" /* ComponentsRole.SHARE_MOBILE */ },
                { id: 'comp-l1opi7vx', role: "cartIcon" /* ComponentsRole.CART_ICON */ },
                { id: 'comp-kzdxtrty', role: "downloadBox" /* ComponentsRole.DOWNLOAD_CONTAINER */ },
                { id: 'comp-kzdxtru03', role: "downloadButton" /* ComponentsRole.DOWNLOAD_BUTTON */ },
                { id: 'comp-l1uvxmyc2', role: "downloadMobile" /* ComponentsRole.DOWNLOAD_MOBILE */ },
                { id: 'comp-kzdxtruq1', role: "facebook" /* ComponentsRole.FACEBOOK */ },
                { id: 'comp-kzdxtruo3', role: "pinterest" /* ComponentsRole.PINTEREST */ },
                { id: 'comp-kzdxtrun', role: "twitter" /* ComponentsRole.TWITTER */ },
                { id: 'comp-kzdxtrul1', role: "tumblr" /* ComponentsRole.TUMBLR */ },
                { id: 'comp-kzdxtruj2', role: "email" /* ComponentsRole.EMAIL */ },
                { id: 'comp-l1w43ekp', role: "loginBox" /* ComponentsRole.LOGIN_BOX */ },
            ],
            controller: 'comp-l1opi7vt2',
        },
        set: {
            // set
            components: [
                { id: 'comp-l1opxpl83', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l1opxpl35', role: "backButton" /* ComponentsRole.BACK_BUTTON */ },
                { id: 'comp-l1opxpkt', role: "heartIcon" /* ComponentsRole.HEART_ICON */ },
                { id: 'comp-l1opxpky', role: "cartIcon" /* ComponentsRole.CART_ICON */ },
                { id: 'comp-kzdxr440', role: "shareBox" /* ComponentsRole.SHARE_CONTAINER */ },
                { id: 'comp-l1uxdlw1', role: "shareMobile" /* ComponentsRole.SHARE_MOBILE */ },
                { id: 'comp-kzdxr43s', role: "downloadBox" /* ComponentsRole.DOWNLOAD_CONTAINER */ },
                { id: 'comp-kzdxr43u1', role: "downloadButton" /* ComponentsRole.DOWNLOAD_BUTTON */ },
                { id: 'comp-l1uxdlvi1', role: "downloadMobile" /* ComponentsRole.DOWNLOAD_MOBILE */ },
                { id: 'comp-l2ogp0n1', role: "nextGalleryButton" /* ComponentsRole.NEXT_GALLERY */ },
                { id: 'comp-kzdxr44y', role: "facebook" /* ComponentsRole.FACEBOOK */ },
                { id: 'comp-kzdxr44w', role: "pinterest" /* ComponentsRole.PINTEREST */ },
                { id: 'comp-kzdxr44u', role: "twitter" /* ComponentsRole.TWITTER */ },
                { id: 'comp-kzdxr44s', role: "tumblr" /* ComponentsRole.TUMBLR */ },
                { id: 'comp-kzdxr44q', role: "email" /* ComponentsRole.EMAIL */ },
                { id: 'comp-l1w45esc', role: "loginBox" /* ComponentsRole.LOGIN_BOX */ },
            ],
            controller: 'comp-l1opxpkv',
        },
        classic: {
            // cover - classic
            components: [
                { id: 'comp-kyacfge8', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-kyhsosnr', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-kyhxv9d1', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-kyacfgdm', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6djjcli', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-kyachx28', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l1opm5z14',
        },
        minimal: {
            // cover - minimal
            components: [
                { id: 'comp-ky1prhyo', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-kyofedwb', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-kyzs6t22', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-ky1prhy72', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6ddc0md', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-kyhvgkcj', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l1tgtccb',
        },
        timeless: {
            // cover - timeless
            components: [
                { id: 'comp-kyagmqzy', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-kyhs5npm', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-kyafe10q', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-kyagmr0f', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6db8njs', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-kyadzf0c', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l1tgnzqv',
        },
        modern: {
            // cover - modern
            components: [
                { id: 'comp-kyhuq92x', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-kzl6fcaf', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-kyaoudr2', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-kyrmzt0o4', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6djq480', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-kyaru6kc', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l1tgpwzm',
        },
        formal: {
            // cover - formal
            components: [
                { id: 'comp-kyho3fph', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-kyofoa01', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-kyofnhib', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-kyho3fp7', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6derl0q', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-kyho3for', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l1tgufa03',
        },
        halfhalf: {
            // cover - halfhalf
            components: [
                { id: 'comp-kyiis1p02', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l6d8oqjn', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-kyij9dkl', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-kyiis1oi', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6dj9pyy', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-kyiis1nn', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l23mv61t',
        },
        gradientleft: {
            // cover - GradientLeft
            components: [
                { id: 'comp-l0i0fs3v', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l0i0fs4b', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-l0i0fs5f', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-l0i0fs3n', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6deee0b', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-l0i0xacx', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l23mxda7',
        },
        infoleft: {
            // cover - infoleft
            components: [
                { id: 'comp-l4fcd097', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l0i0q5en', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-l0i0q5fm', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-l4fcd08y', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6de64ml', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-l0i0q5d1', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l23mvv5e9',
        },
        gradientbottom: {
            // cover - gradientBottom
            components: [
                { id: 'comp-l0i19j6o', role: "title" /* ComponentsRole.TITLE */ },
                { id: 'comp-l0i19j74', role: "logo" /* ComponentsRole.LOGO */ },
                { id: 'comp-l0i19j84', role: "coverButton" /* ComponentsRole.COVER_BUTTON */ },
                { id: 'comp-l0i19j68', role: "moreInfo" /* ComponentsRole.MORE_INFO */ },
                { id: 'comp-l6df84w8', role: "photographerName" /* ComponentsRole.PHOTOGRAPHE_NAME */ },
                { id: 'comp-l0i19j3o', role: "coverImage" /* ComponentsRole.COVER_IMAGE */ },
            ],
            controller: 'comp-l23my69g7',
        },
    },
};
//# sourceMappingURL=templates.js.map